import { ANALYTICS } from '../../constants/common';
import { trackFormInput, trackFormWorkFlow } from './analyticEvents';

/**
 * @method trackFileExtractionInitiate
 * @description this method tracks the file extraction initiation
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileExtractionInitiate = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.INITIATED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackFileExtractionComplete
 * @description this method tracks the file extraction complete
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileExtractionComplete = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.COMPLETED,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackFileExtractionError
 * @description this method tracks the file extraction error
 * @param {string} formName (form name) [name of the form]
 */
export const trackFileExtractionError = (formName: string) => {
  trackFormWorkFlow(
    formName,
    ANALYTICS.FORM_ACTION.ERROR,
    ANALYTICS.STEP,
    ANALYTICS.PAGE_LOAD,
    ''
  );
};

/**
 * @method trackfileExtractionUsage
 * @description tracks the usage of file upload feature
 * @param {string} formName (form name) [name of the form]
 * @param {string} userEncodedNtid (user encoded ntid ) [user encoded ntid]
 */
export const trackfileExtractionUsage = (
  fromName: string,
  userEncodedNtid: string
) => {
  // track user encode ntid
  if (userEncodedNtid !== '') {
    trackFormInput(
      fromName,
      ANALYTICS.NUMBER_ONE,
      ANALYTICS.USER_ENCODED_NTID_QUESTION_NAME,
      userEncodedNtid,
      '1'
    );
  }
};
